import { JSX, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useUiTheme } from 'app/hooks/useUiTheme';
import { UiTheme } from 'app/state/GeneralContext/contexts';

import AccountMenuItem, { SubItem } from './AccountMenuItem';

// Component Definition
const ThemeMenuItem = (): JSX.Element => {
  const { t } = useTranslation('components');

  const {
    theme,
    updateTheme,
  } = useUiTheme();

  const handleUpdateTheme = useCallback((newTheme: UiTheme) => () => {
    updateTheme(newTheme);
  }, [updateTheme]);

  const subItems = useMemo<SubItem[]>(() => {
    return [
      {
        id: 'system',
        label: t('uiThemeMenu.system', 'System'),
        onClick: handleUpdateTheme('system'),
      },
      {
        id: 'light',
        label: t('uiThemeMenu.light', 'Light'),
        onClick: handleUpdateTheme('light'),
      },
      {
        id: 'dark',
        label: t('uiThemeMenu.dark', 'Dark'),
        onClick: handleUpdateTheme('dark'),
      },
    ];
  }, [
    handleUpdateTheme,
    t,
  ]);

  return (
    <AccountMenuItem
      label={t('uiThemeMenu.theme', 'Theme')}
      subItems={subItems}
      subItemSelectedId={theme.toLowerCase()}
    />
  );
};

export default ThemeMenuItem;
